export enum SortFile {
  Filename = 'filename',
  Type = 'contentType',
  Author = 'author',
  Date = 'date'
}



// WEBPACK FOOTER //
// ./src/app/models/sort-file.enum.ts